<template>
  <div id="detalleSolicitudComprobacionRepresentacion" :data-ready="printReady">
    <v-toolbar>
      <img src="@/assets/logo_javer.png" height="60" width="auto">
      <v-spacer></v-spacer>
      <v-toolbar-title>Detalle de solicitud de comprobación de Representación</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card-text>
      <v-container grid-list-md>
        <v-layout wrap>
          <v-flex xs6>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Solicitud Gastos Representacion
              </div>
              <v-select v-model="sol_gastos" :items="solicitudes_gastos" :item-text="formatSolicitud"
                item-value="idsolicitud_gasto_representacion" label="Seleccionar Solicitud" disabled
                @change="onSeleccionarSolicitud"></v-select>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Tipo de gastos
              </div>
              <v-radio-group v-model="solicitud.tipo_gasto" :mandatory="false" disabled
                @input="$v.solicitud.tipo_gasto.$touch()" @blur="$v.solicitud.tipo_gasto.$touch()">
                <v-radio label="Gastos de representación" color="primary" value="representacion" />
                <v-radio label="Gastos de atención al personal" color="primary" value="atencion_personal" />
                <v-radio-group v-if="solicitud.tipo_gasto == 'atencion_personal'" v-model="solicitud.tipo_atencion"
                  @input="$v.solicitud.tipo_atencion.$touch()" @blur="$v.solicitud.tipo_atencion.$touch()"
                  :mandatory="false" class="ml-5 mt-neg">
                  <div slot="label"><strong>Tipo de atencion</strong></div>
                  <v-radio label="Comida de Trabajo" value="comidas_trabajo" />
                  <v-radio label="Reuniones de Integración" value="reuniones_integracion" />
                </v-radio-group>
              </v-radio-group>

              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Tipo de pago
              </div>
              <v-radio-group v-model="solicitud.tipo_pago" :mandatory="false" disabled
                @input="$v.solicitud.tipo_pago.$touch()" @blur="$v.solicitud.tipo_gasto.$touch()">
                <v-radio label="Transferencia" color="primary" value="transferencia" />
                <v-radio label="Cheque" color="primary" value="cheque" />
              </v-radio-group>


            </v-container>
          </v-flex>
          <v-flex xs6>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Responsable
              </div>
              <v-text-field v-model="solicitud.nombre" disabled @input="$v.solicitud.nombre.$touch()"
                @blur="$v.solicitud.nombre.$touch()" label="Nombre" />
              <v-select v-model="solicitud.puesto" :items="catalogos.puestos" disabled :item-text="centroText"
                item-value="idcat_puesto" label="Puesto" @input="$v.solicitud.puesto.$touch()"
                @blur="$v.solicitud.puesto.$touch()" />
              <v-select v-model="solicitud.departamento" disabled :items="catalogos.departamentos"
                :item-text="centroText" item-value="idcat_departamento" label="Departamento"
                @input="$v.solicitud.departamento.$touch()" @blur="$v.solicitud.departamento.$touch()" />
              <v-select v-model="solicitud.direccion" :items="catalogos.direcciones" disabled :item-text="centroText"
                item-value="idcat_direccion" label="Plaza" @input="$v.solicitud.direccion.$touch()"
                @blur="$v.solicitud.direccion.$touch()" />
              <v-select v-model="solicitud.empresa" :items="catalogos.empresas" disabled :item-text="centroText"
                item-value="idcat_empresa" label="Empresa" @input="$v.solicitud.empresa.$touch()"
                @blur="$v.solicitud.departamento.$touch()" />
              <v-select v-model="solicitud.centro" :items="catalogos.centros" disabled :item-text="centroText"
                item-value="idcat_centro_costo" label="Centro de costos" @input="$v.solicitud.centro.$touch()"
                @blur="$v.solicitud.centro.$touch()" />
              <v-text-field v-model="solicitud.asistentes" disabled @input="$v.solicitud.asistentes.$touch()"
                @blur="$v.solicitud.asistentes.$touch()" label="No. Asistentes" type=" number" />

              <h3 class="grey--text firmas-titulo">FIRMAS DE APROBACION</h3><br />
              <v-list three-line class="firmas-list">
                <template v-for="(item, i) in firmas">
                  <v-list-tile class="pb-2 pt-2">
                    <v-list-tile-content>
                      <v-list-tile-title v-html="item.rol"></v-list-tile-title>
                      <v-list-tile-title v-html="item.nombre"></v-list-tile-title>
                      <v-list-tile-sub-title v-html="item.estado"></v-list-tile-sub-title>
                      <v-list-tile-sub-title v-show="item.estado !== 'En aprobación'"
                        v-html="item.fecha_actualizacion"></v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-divider v-show="(i + 1) < firmas.length"></v-divider>
                </template>
              </v-list>
            </v-container>
            <v-container>
              <div class="v-label theme--light titulo-centrado" style="font-weight: bold;">
                Detalle de pago
              </div>
              <v-text-field v-model="solicitud.importe" @input="$v.solicitud.importe.$touch()" disabled
                @blur="$v.solicitud.importe.$touch()" label="Importe" prefix="$" suffix="MXN" type="number" />
              <v-text-field v-model="solicitud.importe_letra" disabled label="No. Facturas" />
              <v-layout wrap>
                <v-flex xs12 sm12 md6>
                  <v-text-field v-model="facturas.subtotal" label="Subtotal" box prefix="$" suffix="MXN"
                    readonly></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                  <v-text-field v-model="facturas.iva" label="IVA" box prefix="$" suffix="MXN" readonly></v-text-field>
                </v-flex>
              </v-layout>
              <h3 class="grey--text">RESUMEN</h3><br />
              <v-data-table v-if="facturas" :headers="headersResumen" :items="facturas.detalle"
                style="width: calc(100% + 50px);" hide-actions no-data-text="">
                <template slot="items" slot-scope="props">
                  <td class="text-xs-right">{{ mapTipo(props.item.tipo_gasto) }}</td>
                  <td class="text-xs-right">{{catalogos.conceptos.filter(concepto => {
                    return concepto.id ==
                      props.item.idcat_concepto
                  })[0].descripcion}}</td>
                  <td class="text-xs-right">{{ props.item.fecha_timbrado }}</td>
                  <!--<td class="text-xs-right">{{ props.item.proveedor }}</td>-->
                  <td class="text-xs-right">{{ props.item.subtotal }}</td>
                  <!-- <td class="text-xs-right">{{ props.item.iva }}</td>
                    <td class="text-xs-right">{{ props.item.total }}</td> -->
                </template>
              </v-data-table>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </div>
</template>

<script>
import services from '@/config/services';
import axios from 'axios';
import printReady from '@/utils/printReady';

export default {
  name: 'detalleSolicitudComprobacionRepresentacion',
  mixins: [printReady],
  data: () => ({
    mapTipo(value) {
      const map = {
        deducible: 'DEDUCIBLE',
        no_deducible: 'NO DEDUCIBLE'
      }
      return map[value] || value
    },
    headersResumen: [
      {
        text: "TIPO DE GASTO",
        align: "center",
        sortable: false,
        value: "tipo_gasto"
      },
      { text: "CONCEPTO", align: "center", sortable: false, value: "concepto" },
      {
        text: "FECHA DE TIMBRADO",
        align: "center",
        sortable: false,
        value: "fecha_timbrado"
      },
      /*{ text: 'PROVEEDOR', align: 'center', sortable: false, value: 'proveedor' },*/
      {
        text: "SUB TOTAL", align: "center", sortable: false, value: "subtotal"
      },
      // { text: "IVA", align: "center", sortable: false, value: "iva" },
      // { text: "TOTAL", align: "center", sortable: false, value: "total" }
    ],
    tipos_pago: ['Transferencia', 'Cheque'],
    sol_gastos: null,
    solicitudes_gastos: [],
    firmas: [],
    solicitud: {},
    facturas: {
      subtotal: 0,
      iva: 0,
      detalle: []
    },
    catalogos: {
      departamentos: [],
      direcciones: [],
      empresas: [],
      centros: [],
      puesto: []
    },
    loading: false,
  }),
  mounted() {
    this.fetchSolicitudes()
  },
  methods: {
    ws(method, name, data) {
      if (method === "get") {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          let params = "";
          for (let k in data) {
            params += k + "=" + data[k] + "&";
          }
          params = params !== "" ? "?" + params : "";
          return axios
            .get(services.routes[name] + params, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      } else {
        if (this.$session.exists()) {
          let jwt = this.$session.get("jwt");
          let headers = {
            Authorization: "Bearer " + jwt
          };
          return axios
            .post(services.routes[name], data, { headers })
            .then(response => {
              let res = response.data;
              if (res.correcto) {
                return { ok: true, data: res.data, message: res.mensaje };
              } else {
                return { ok: false, message: res.mensaje };
              }
            })
            .catch(error => {
              console.log(error);
              error.response.status === 403 && this.$router.push("/403");
              return {
                ok: false,
                message:
                  "El servicio no se encuentra disponible en estos momentos"
              };
            });
        } else {
          this.$router.push("/login");
        }
      }
    },
    centroText(item) {
      return `${item.idexterno} - ${item.descripcion}`;
    },
    updateTotales() {
      let subtotal = 0;
      let iva = 0;
      for (let f of this.facturas.detalle) {
        subtotal += Number(f.subtotal)
        iva += Number(f.iva)
      }
      this.facturas.subtotal = subtotal
      this.facturas.iva = iva
    },
    async onSeleccionarSolicitud(data) {
      this.loading = true;
      try {
        this.solicitud.tipo_gasto = data.tipo_gasto
        if (this.solicitud.tipo_gasto == 'atencion_personal') {
          this.solicitud.tipo_atencion = data.subtipo_atencion
        }
        this.solicitud.tipo_pago = data.tipo_pago
        this.solicitud.nombre = data.nombre_responsable
        this.catalogos.departamentos.push(data.idcat_departamento)
        this.solicitud.departamento = data.idcat_departamento
        this.catalogos.direcciones.push(data.idcat_direccion)
        this.solicitud.direccion = data.idcat_direccion
        this.catalogos.empresas.push(data.idcat_empresa)
        this.solicitud.empresa = data.idcat_empresa
        this.catalogos.centros.push(data.idcat_centro_costo)
        this.solicitud.centro = data.idcat_centro_costo
        const puesto = this.catalogos.puestos.find(
          e => e.descripcion === data.puesto
        );
        if (puesto) {
          this.solicitud.puesto = puesto.idcat_puesto;
        }

        this.solicitud.asistentes = data.numero_asistentes
        this.solicitud.importe = data.importe
        this.solicitud.observaciones = data.observaciones
        this.solicitud.importe_letra = data.importe_letra

        this.facturas.detalle = []
        this.updateTotales()
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {
        this.loading = false;
      }
    },
    formatSolicitud(item) {
      if (!item) return '';
      return `${item.idsolicitud_gasto_representacion} - ${this.mapTipoGasto(item.tipo_gasto)} - ${this.formatCurrency(item.importe)}`;
    },
    calcularTotales() {
      let subtotal = 0.0
      let descuento = 0.0
      let iva = 0.0
      let total = 0.0
      for (let i = 0; i < this.solicitud.comprobantes.detalle.length; i++) {
        subtotal += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].subtotal).toFixed(
            2
          )
        );
        descuento += parseFloat(
          parseFloat(
            this.solicitud.comprobantes.detalle[i].descuento
          ).toFixed(2)
        );
        iva += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].iva).toFixed(2)
        );
        total += parseFloat(
          parseFloat(this.solicitud.comprobantes.detalle[i].total).toFixed(2)
        );
      }

      this.solicitud.comprobantes.subtotal = subtotal.toFixed(2);
      this.solicitud.comprobantes.iva = iva.toFixed(2);
      this.solicitud.comprobantes.descuento = descuento.toFixed(2);
      this.solicitud.comprobantes.importe_total = total.toFixed(2);
    },
    mapTipoGasto(value) {
      const map = {
        representacion: 'Gastos de representación',
        atencion_personal: 'Atención al personal'
      }
      return map[value] || value
    },
    formatCurrency(val) {
      return new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(val || 0);
    },
    formatDateShort(date) {
      if (!date) return '';
      const d = new Date(date.toLocaleString('en-US', { timeZone: 'America/Mexico_City' }));
      const pad = (n) => n.toString().padStart(2, '0');
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    },

    async fetchSolicitudes() {
      let idsolicitud = this.$route.query.idsolicitud;
      this.loading = true;
      try {
        var token = this.$route.query.token
        this.$session.start()
        this.$session.set('jwt', token)
        const res = await this.ws("post", "obtenerCatalogo", { tableName: 'cat_puestos' })
        if (res.ok) {
          this.catalogos.puestos = res.data.datos
        } else {
          this.error = true
          this.msgError = res.message
        }
        const det = await this.ws("get", "detalleUsuario")
        if (res.ok) {
          this.catalogos.conceptos = det.data.catalogos.conceptos;
        } else {
          this.error = true
          this.msgError = det.message
        }
        const jwt = this.$session.get("jwt");
        const headers = { Authorization: "Bearer " + jwt };
        const url = services.routes.representacionComprobacionSolicitudDetalle.replace(
          ":id",
          idsolicitud
        );
        const { data } = await axios.get(url, { headers });
        this.solicitudes_gastos.push(
          data.idsolicitud_gasto_representacion
        )

        await this.onSeleccionarSolicitud(data.idsolicitud_gasto_representacion)
        this.sol_gastos = data.idsolicitud_gasto_representacion.idsolicitud_gasto_representacion
        this.firmas = data.firmas
        this.facturas.detalle = data.comprobantes
        this.updateTotales()
        this.markPrintReady()
      } catch (err) {
        console.error("Error al cargar detalle:", err);
      } finally {

        this.loading = false;
      }
    },
  }
}
</script>
